

















































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "QrFooter"
})
export default class QrFooter extends Vue {

 @Prop({type: String || null, default: null})  email!:string | null
 @Prop({type: Number || null, default: 0})  countBadges!:number | null
 @Prop({type: Number || null, default: 0})  countProducts!:number | null
 @Prop({type: Number || null, default: 0})  countStands!:number | null
}
